import React, { useState } from "react";
import { Layout, Menu, Input } from "antd";
import { Link } from "react-router-dom";
import {
  BarsOutlined,
  ShoppingCartOutlined,
  FolderOpenOutlined,
  ApartmentOutlined,
  DashboardOutlined,
  UserOutlined,
  FileImageOutlined,
  SettingOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";

import { IMAGE_BASE_URL } from "../../constants/api";
import assets from "../../utils/ImagesPath";
import LS_SERVICE from "../../utils/localStorage";

const siderStyle = {
  overflow: "auto",
  height: "95vh",
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
  scrollbarWidth: "thin",
  scrollbarGutter: "stable",
};

// Menu Sections
const menuCategories = [
  {
    category: "Dashboard",
    items: [
      {
        key: "dashboard",
        icon: <DashboardOutlined />,
        label: "Dashboard",
        to: "/",
      },
    ],
  },
  {
    category: "Content Management",
    items: [
      {
        key: "file-manager",
        icon: <FolderOpenOutlined />,
        label: "File Manager",
        to: "/file-manager",
      },
      {
        key: "slider",
        icon: <FileImageOutlined />,
        label: "Slider",
        to: "/slider",
      },
      {
        key: "popup",
        icon: <FileImageOutlined />,
        label: "Popup",
        to: "/popup",
      },
      {
        key: "testimonial",
        icon: <UserOutlined />,
        label: "Testimonial",
        to: "/testimonial",
      },
      {
        key: "coupon",
        icon: <UserOutlined />,
        label: "Coupon's",
        to: "/coupon",
      },
    ],
  },
  {
    category: "Inventory & Master",
    items: [
      { key: "brand", icon: <BarsOutlined />, label: "Brand", to: "/brand" },
      {
        key: "category",
        icon: <BarsOutlined />,
        label: "Category",
        to: "/category",
      },
      {
        key: "sub-category",
        icon: <BarsOutlined />,
        label: "Sub-Category",
        to: "/sub-category",
      },
      {
        key: "product",
        icon: <ShoppingCartOutlined />,
        label: "Product's",
        to: "/product",
      },
      {
        key: "inventory",
        icon: <ApartmentOutlined />,
        label: "Inventory",
        to: "/product-inventory",
      },
    ],
  },
  {
    category: "User & Customer Management",
    items: [
      {
        key: "customer",
        icon: <UserOutlined />,
        label: "Customer",
        to: "/customer",
      },
      { key: "staff", icon: <UserOutlined />, label: "Staff", to: "/user" },
    ],
  },
  {
    category: "Order's & Message",
    items: [
      {
        key: "orders",
        icon: <ShoppingCartOutlined />,
        label: "Order's",
        to: "/order",
      },
      {
        key: "accept-order",
        icon: <ShoppingCartOutlined />,
        label: "Accept Order's",
        to: "/order/accept",
      },
      {
        key: "shipped-order",
        icon: <ShoppingCartOutlined />,
        label: "Shipped Order's",
        to: "/order/shipped",
      },
      {
        key: "delivered-order",
        icon: <ShoppingCartOutlined />,
        label: "Delivered Order's",
        to: "/order/delivered",
      },
      {
        key: "cancel-order",
        icon: <ShoppingCartOutlined />,
        label: "Cancel Order's",
        to: "/order/canceled",
      },
      {
        key: "contacts",
        icon: <ShoppingCartOutlined />,
        label: "Contact's",
        to: "/contacts",
      },
    ],
  },
  {
    category: "Content & Settings",
    items: [
      {
        key: "dynamic-content",
        icon: <FileSearchOutlined />,
        label: "Dynamic Content",
        to: "/pages",
      },
      {
        key: "setting",
        icon: <SettingOutlined />,
        label: "Setting",
        to: "/setting",
      },
      {
        key: "profile",
        icon: <SettingOutlined />,
        label: "Profile",
        to: "/profile/update",
      },
    ],
  },
];

const MenuSection = ({ category, items }) => (
  <Menu.ItemGroup title={category}>
    {items.map(({ key, icon, label, to }) => (
      <Menu.Item key={key} icon={icon}>
        <Link to={to}>{label}</Link>
      </Menu.Item>
    ))}
  </Menu.ItemGroup>
);

function Drawer() {
  const [collapsed, setCollapsed] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const { Sider } = Layout;

  const { logo } = LS_SERVICE.get("setting") || {};
  const { favicon } = LS_SERVICE.get("setting") || {};
  const logoSrc = logo
    ? `${IMAGE_BASE_URL}${collapsed ? favicon : logo}`
    : assets.logo;

  const filteredMenuCategories = menuCategories
    .map(({ category, items }) => ({
      category,
      items: items.filter((item) =>
        item.label.toLowerCase().includes(searchTerm.toLowerCase())
      ),
    }))
    .filter(({ items }) => items.length > 0);

  return (
    <Sider
      width={240}
      style={siderStyle}
      theme="light"
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
    >
      <div
        style={{
          paddingTop: "10px",
          paddingLeft: "10px",
          paddingRight: "10px",
        }}
      >
        <img className="logo" src={logoSrc} alt="Logo" />
        <br />
        <Input
          placeholder="Search menu"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <Menu theme="light" mode="inline" defaultSelectedKeys={["dashboard"]}>
        {filteredMenuCategories.map(({ category, items }) => (
          <MenuSection key={category} category={category} items={items} />
        ))}
      </Menu>
    </Sider>
  );
}

export default Drawer;
